<div *ngIf="isShowNoti" class="fixed top-5 right-5 w-60 md:w-96 z-[1001]">
  <nz-alert
    [nzType]="notification.type" 
    [nzMessage]="notification.title"
    [nzDescription]="notification.message"
    nzShowIcon>
  </nz-alert>
</div>